module.exports = __webpack_public_path__ + "img/contact_map_background_sm.8420cc2f.png";